module.exports = __webpack_public_path__ + "img/manual.0f927e68.svg";